import React from "react";
import { View, StyleSheet } from "react-native";
import { Menu } from "react-native-paper";

interface DegreesMenuProps {
  visible: boolean;
  onDismiss: () => void;
  anchor: { x: number; y: number };
  onChangeName: () => void;
  onDeleteDegree: () => void;
}

const DegreesMenu: React.FC<DegreesMenuProps> = ({ visible, onDismiss, anchor, onChangeName, onDeleteDegree }) => {
  return (
    <Menu visible={visible} onDismiss={onDismiss} anchor={anchor} contentStyle={styles.menu}>
      <Menu.Item onPress={onChangeName} title="Change Name" titleStyle={styles.menuItemText} />
      <View style={styles.menuDivider} />
      <Menu.Item onPress={onDeleteDegree} title="Delete Degree" titleStyle={[styles.menuItemText, styles.deleteText]} />
    </Menu>
  );
};

const styles = StyleSheet.create({
  menu: {
    backgroundColor: "#fff",
    minWidth: 200,
  },
  menuItemText: {
    fontSize: 14,
    color: "#374151",
  },
  deleteText: {
    color: "#DC2626",
  },
  menuDivider: {
    height: 1,
    backgroundColor: "#E5E7EB",
    marginVertical: 4,
  },
});

export default DegreesMenu;
